import React from "react";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";

import classes from "./Input.module.css";

interface Props {
  label?: string;
  type?: string;
  mandatoryLabel?: {};
  supportLabel?: string;
  placeholder?: string;
  elementLabelStyle?: {};
  elementInputStyle?: {};
  name: string;
  errorText: string;
  value: string;
  onChange?: (event) => void;
  onKeyUp?: (event) => void;
  onFocus?: (event) => void;
  onBlur?: (event) => void;
  readOnly?: boolean;
}

const input: React.FunctionComponent<Props> = (props) => {
  const {
    label,
    type,
    mandatoryLabel,
    supportLabel,
    placeholder,
    elementLabelStyle,
    elementInputStyle,
    name,
    errorText,
    value,
    onChange,
    onKeyUp,
    onFocus,
    onBlur,
    readOnly,
  } = { ...props };
  return (
    <FormGroup className={classes.formGroup}>
      <FormLabel style={elementLabelStyle} className={classes.formLabel}>
        {label}
        {mandatoryLabel}
        <small>{supportLabel}</small>
      </FormLabel>
      <FormControl
        type={type ? type : "text"}
        size="lg"
        placeholder={placeholder}
        style={elementInputStyle}
        className={classes.controlCustom}
        name={name}
        value={value}
        onChange={onChange}
        onKeyUp={onKeyUp}
        onFocus={onFocus}
        onBlur={onBlur}
        readOnly={readOnly}
      />
      <span className={classes.errorMsg}>{errorText}</span>
    </FormGroup>
  );
};
export default input;
